import { Upload, notification, Button, Tooltip } from "antd";
import * as React from "react";
import { UploadChangeParam, UploadProps } from "antd/lib/upload/interface";

import "./PbrDocUploader.scss";

export interface IFileToUpload {
    name: string;
    file: string;
    type: string;
}

export default function PbrDocUploader(
    props: UploadProps & {
        onChangeBase64?: (fileToUpload: IFileToUpload) => void;
        initialImgUrl?: string;
        setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
        hoverText?: string;
        hoverTextDisabled?: string;
        disabled?: boolean;
    },
) {
    function getBase64(file): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.toString() || "");
            reader.onerror = error => reject(error);
            
        });
    }

    async function handleChange(info: UploadChangeParam) {

        try {
            const base64 = await getBase64(info.file);
            if (props.onChangeBase64) {
                props.onChangeBase64({ file: base64.split("base64,")[1], name: info.file.name, type: info.file.type });
            }
        } catch (error) {
            notification["error"]({
                message: "Erro ao carregar o arquivo",
                description: "Ocorreu um erro no carregamento do arquivo",
            });
            console.log(error);
        }
    }

    return (
        <>
            <Upload
                disabled={props.disabled}
                className="doc-uploader"
                name="avatar"
                showUploadList={false}
                beforeUpload={(file, fileList) => false}
                onChange={info => {
                    handleChange(info);
                }}
                action={() => null}
                accept="image/jpeg,image/png"
            >
                <Tooltip title={props.hoverText ? (props.disabled && props.hoverTextDisabled ? props.hoverTextDisabled : props.hoverText) : "Upload Document"}>
                    <Button icon={"upload"} style={{ width: "40px" }} disabled={props.disabled}/>
                </Tooltip>
            </Upload>
        </>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrDocUploaderTradeId/PbrDocUploader.tsx